import React, {Component} from 'react'
import close from './img/close.png'
import search from './img/search.png'
import noProfilePhoto from './img/no-profile-photo.png'
import menu from './img/menu.png'
import circledMenu from './img/circled-menu.png'
import ENV from '../../env'
import SearchInput from './SearchInput'
import menuWithOrderItems from './img/menu-with-order-items.png'
import ActionItem from "./ActionItem";
import cartWithOrderItems from "./img/cart-with-order-items.png";
import cart from "./img/cart.png";
import SendToTnAccountContainer from "../../auth/SendToTnAccount";

class MobileHead extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showSearch: false
    }
  }

  showSearch = () => {
    this.setState({showSearch: true})
  }

  hideSearch = () => {
    this.setState({showSearch: false})
  }

  render() {
    const language = this.props.language ? this.props.language : 'sr';
    const cartUrl = ENV.root_path + ENV.webshop_path + '/' + language + '/Privatni-korisnici/Kupovina'
    return (
      <div className={`mobile-head container-fluid ${this.state.showSearch ? 'searchVisible' : ''}`}>
        <div className={'row p-2'}>
          {this.state.showSearch ?
            <SearchInput handleSearchClose={this.hideSearch} language={language}
                         section={this.props.section}/> :
            <React.Fragment>
              <div className={'col-sm-4 col-4 p-0 text-center'}>
                <a href='https://www.yettel.rs/' className="logo-link">
                  <span className="yettel-bold-font">Yettel.</span>
                </a>
              </div>
              <div className={'col-sm-8 col-8 p-0 text-center d-flex justify-content-end align-items-center'}>
                <img width="28" alt={'search'} className="d-block mx-1" src={search} onClick={this.showSearch}/>
                <a href={cartUrl}>
                  {this.props.numberOfOrderItems > 0 ?
                    <ActionItem alt="Cart with order items" src={cartWithOrderItems} title={''} url={cartUrl}/> :
                    <ActionItem alt="Cart" src={cart} title={''} url={cartUrl}/>
                  }
                </a>
                <img width="32" alt={'circled-menu'} className="d-block mx-1" src={circledMenu}
                     onClick={this.props.handleYettelAppsClick}/>
                {this.props.isLoggedIn ?
                  <>
                    <div style={{width: 0, visibility: "hidden"}}>
                      <SendToTnAccountContainer setShouldCallLogin={this.props.setShouldCallLogin}
                                                cookie={this.props.cookie} from={window.location.href} isWhite={false}
                                                isTextVisible={false}/>

                    </div>
                    <img alt={'logged'} className="icon mx-1 d-block" src={noProfilePhoto}
                         onClick={this.props.handleLoginClick}/>
                  </> :
                  <SendToTnAccountContainer setShouldCallLogin={this.props.setShouldCallLogin}
                                            cookie={this.props.cookie} from={window.location.href} isWhite={false}
                                            isTextVisible={false}/>
                }
                {this.props.menuVisibility && !this.props.showLogin && !this.props.showYettelApps ?
                  <img alt={'close'} className="icon mx-1 d-block pull-right" src={close}
                       onClick={this.props.handleCloseMenu}/> :
                  <React.Fragment>
                    {this.props.numberOfOrderItems > 0 ?
                      <img alt={'menu with order items'} className="icon mx-1 d-block pull-right"
                           src={menuWithOrderItems} onClick={this.props.handleShowMenu}/> :
                      <img alt={'menu'} className="icon mx-1 d-block pull-right" src={menu}
                           onClick={this.props.handleShowMenu}/>
                    }
                  </React.Fragment>
                }
              </div>
            </React.Fragment>
          }
        </div>
      </div>
    )
  }
}

export default MobileHead
